import { styled,css } from '../../../../style';

const SortSelectDivStyled = styled('div')(
    ({ theme }) => css`
    .react-select__control {
      background: ${theme.colors.selectBox};
      display: flex;
      font-size: 14px;
      width: 120px;
      margin-right: 10px;
      border: 1px solid ${theme.colors.selectBorder};
      border-radius: 12px;
      color: ${theme.colors.selectText};
    }
  
    .react-select__indicator-separator {
      background: ${theme.colors.selectBox};
      color: ${theme.colors.selectBox};
    }
  
    .react-select__menu {
      background: ${theme.colors.selectBox};
      width: 120px;
      border: 1px solid ${theme.colors.selectBox};
      border-radius: 12px;
      color: ${theme.colors.selectText};
    }
  
    .react-select__single-value {
      color: ${theme.colors.selectText} !important;
    }
  
    .option-icon {
      width: 24px;
      height: 24px;
      margin-right: 4px;
      border: 1px solid  ${theme.colors.selectBox};
      border-radius: 24px;
    }
  
    .control-icon {
      width: 24px;
      height: 24px;
      margin-left: 13px;
      border: 1px solid  ${theme.colors.selectBox};
      border-radius: 24px;
    }
  
    .select-option {
      display: flex;
      align-items: center;
      flex-direction: row;
      font-size: 14px;
      cursor: pointer;
      color: ${theme.colors.selectText};
      background: ${theme.colors.selectBox};
    }
    `
  );

  export default SortSelectDivStyled;
  